import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useParticipantPhoneNumberConfig from './ParticipantPhoneNumberGroup.config';
import { commonFields } from 'modules/events/basics/constants/commonFormFields.constants';
import { useYodaForm } from 'yoda-ui/yodaForm';

const useParticipantPhoneNumber = () => {
  const { t } = useTranslation();
  const { useWatchField, setValue } = useYodaForm();

  const { participantPhoneNumberConfig } = useParticipantPhoneNumberConfig(
  );
  const isCollectParticipantPhoneNumberEnabled = useWatchField(commonFields.collectParticipantPhoneNumber);

  useEffect(() => {
    if (!isCollectParticipantPhoneNumberEnabled?.value) {
      setValue(commonFields.collectPhoneNumberMandatory, false);
      setValue(commonFields.collectTextMessageUserConsent, false);
    }
  }, [isCollectParticipantPhoneNumberEnabled?.value, setValue]);

  return {
    isCollectParticipantPhoneNumberEnabled: isCollectParticipantPhoneNumberEnabled?.value,
    participantPhoneNumberConfig,
    t,
  };
};

export default useParticipantPhoneNumber;
